import { Content } from '../../types';

export const chiangRaiToChiangMaiContent: Content = {
  title: "טיול יום מצ'אנג ראי לצ'אנג מאי – חוויות טבע, מפלים ומעיינות חמים",
  imageUrl:
    '/images/thailand/chiang-rai-to-chiang-mai/chiang-rai-to-chiang-mai-wide.jpeg',
  introduction:
    "המסלול מצ'אנג ראי לצ'אנג מאי מציע חוויית טבע בלתי נשכחת, עם עצירות בפארקים, מפלים מרשימים ונקודות עניין ייחודיות בדרך. זהו יום טיול מרהיב המשלב יערות טרופיים, נופים ירוקים ומרחצאות חמים טבעיים, כל זאת קודם להגעה לעיר צ'אנג מאי.",
  sections: [
    {
      title: 'הפארק הלאומי Lam Nam Kok National Park',
      type: 'text',
      content:
        "פארק זה, הממוקם מערבית לצ'אנג ראי, ידוע בנופיו המרהיבים, הנהרות הזורמים והצמחייה הטרופית העשירה. ניתן לצאת כאן למסלול טיול קצר ביער, ליהנות משלוות הטבע ולבקר בכפרים של שבטים מקומיים החיים באזור.",
    },
    {
      title: 'מפלים מרשימים בדרך',
      type: 'sub-headers',
      description:
        'בהמשך המסלול נעצור במספר מפלים מרהיבים שמציעים חוויית טבע עוצרת נשימה:',
      content: [
        {
          subtitle: 'Huai Kaeo Waterfall',
          text: 'המפל Huai Kaeo הוא יעד נהדר להתרעננות ולתצפית על מפל מים טבעי בלב היער. המקום נעים לשכשוך רגליים ולהתענג על האווירה הפסטורלית.',
        },
        {
          subtitle: 'Khun Korn Forest Park Waterfall',
          text: "אחד המפלים הגבוהים והמרהיבים באזור צ'אנג ראי, בגובה של כ-70 מטרים. מסלול ההליכה אל המפל עובר ביער טרופי שופע, ומציע חווית טבע אותנטית.",
        },
      ],
    },
    {
      title: 'ביקור ב-Singha Park',
      type: 'text',
      content:
        'לאחר הביקור במפלים, מומלץ להגיע ל-Singha Park – <strong>(אתר חובה למשפחות עם ילדים)</strong> מתחם טבע פתוח עם גבעות ירוקות, שדות תה ונוף מרהיב. הפארק מציע מסלולי אופניים, סיורי חוות חקלאיות ואף אפשרות לטעום תה מקומי.',
    },
    {
      title: "נסיעה לצ'אנג מאי דרך כבישים 1, 120 ו-118",
      type: 'text',
      content: `לאחר הביקורים בצ'אנג ראי וסביבתה, יוצאים לנסיעה לכיוון צ'אנג מאי, דרך כבישים נופיים (1 + 120 + 118), מרחק של כ-300 ק"מ. הדרך עוברת בנופים הרריים ויערות טרופיים, עם אפשרויות עצירה במקומות מעניינים לאורך המסלול.`,
    },
    {
      title: "מעיינות חמים בדרך לצ'אנג מאי",
      type: 'sub-headers',
      description: 'אחת האטרקציות המרגיעות בדרך הן המעיינות החמים הטבעיים:',
      content: [
        {
          subtitle: 'Mae Katchan Hot Springs',
          text: 'מעיינות חמים טבעיים הממוקמים לאורך כביש 118. זהו מקום פופולרי לעצירה קצרה, שבו ניתן לטבול רגליים במים החמים או להרתיח ביצים בתוך בריכות המעיינות.',
        },
        {
          subtitle: 'Doi Saket Hot Springs',
          text: "בקרבת צ'אנג מאי, המעיינות החמים Doi Saket מציעים חווית רחצה נעימה. המקום שקט ומרגיע, אידיאלי למנוחה לפני הכניסה לעיר הסואנת.",
        },
      ],
    },
    {
      title: "סיום המסלול בצ'אנג מאי",
      type: 'text',
      content:
        "לאחר יום מלא בחוויות טבע ונופים מדהימים, מגיעים לצ'אנג מאי – עיר התרבות וההיסטוריה של צפון תאילנד. ניתן לסיים את היום בארוחה מקומית, להירגע באחד מבתי התה בעיר העתיקה, או לטייל בשוקי הלילה המפורסמים.",
    },
    {
      title: 'בשורה התחתונה',
      content:
        'בשורה התחתונה, טיול זה מציע שילוב מושלם בין טבע, נופים מרהיבים ותרבות מקומית והופך את המעבר בין שתי הערים לחוויה בלתי נשכחת.',
      type: 'text',
      isBold: true,
    },
  ],
};
